import { ready } from '~/core'

ready('collapsible-drawer', '.collapsible-drawer', (root) => {
  const drawer = root.querySelector('.collapsible-drawer__drawer')
  const overlay = root.querySelector('.collapsible-drawer__overlay')
  const titleWrapper = root.querySelector('.collapsible-drawer__title-wrapper')
  const mobileButton = root.querySelector('.collapsible-drawer__mobile-button')
  const closeButton = root.querySelector('.collapsible-drawer__close')
  const focusTrap = root.querySelector('.collapsible-drawer__focus-trap')

  const dropdown = root.querySelector('.webinars__dropdown select')
  const iframe = root.querySelector('.iframe')

  const SCREEN_WIDTH_EXTRA_LARGE = 1500
  const SCREEN_WIDTH_LARGE = 992
  const SCREEN_WIDTH_SMALL = 576
  const DRAWER_WIDTH_DESKTOP = 390
  const RATES_PAGE_PADDING = 32

  attachToggleListenerToDrawer()
  attachCloseListenerToOverlay()
  closeDrawerOnPageLoad()

  window.addEventListener('DOMContentLoaded', () => adjustDrawerPosition())
  window.addEventListener('resize', () => adjustDrawerPosition())

  function closeDrawerOnPageLoad() {
    if (isMobileScreen()) {
      root.classList.remove('is-open')

      return
    }

    setTimeout(() => {
      root.classList.remove('is-open')
    }, 2000)
  }

  function adjustDrawerPosition() {
    if (isMobileScreen() || isTabletScreen()) {
      drawer.style.left = null
      drawer.style.visibility = 'visible' // we're hiding the drawer until this script loads and positions it correctly

      return
    }

    if (isExtraLargeScreen()) {
      const leftOffset = getDistanceBetweenRightContentAndPageEdge()

      drawer.style.left = `${leftOffset - DRAWER_WIDTH_DESKTOP}px`
      drawer.style.visibility = 'visible' // we're hiding the drawer until this script loads and positions it correctly

      return
    }

    drawer.style.left = `${RATES_PAGE_PADDING}px`
    drawer.style.visibility = 'visible' // we're hiding the drawer until this script loads and positions it correctly
  }

  function getDistanceBetweenRightContentAndPageEdge(paddingOffsetInPixels = 0) {
    const element = document.querySelector('.rates-page__right')
    const rect = element?.getBoundingClientRect()

    return (rect?.left || 0) - paddingOffsetInPixels
  }

  function attachToggleListenerToDrawer() {
    if (titleWrapper) {
      titleWrapper.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()

        root.classList.toggle('is-open')
      })

      titleWrapper.addEventListener('keydown', (event) => {
        const isEnterKey = (event.key || '').toLowerCase() === 'enter'
        const isTabKey = (event.key || '').toLowerCase() === 'tab'

        if (isEnterKey) {
          event.preventDefault()
          root.classList.toggle('is-open')
        }

        if (isTabKey && event.shiftKey) {
          const isOpen = root.classList.contains('is-open')

          if (isOpen) {
            event.preventDefault()
            iframe.focus()
          }
        }
      })
    }

    if (focusTrap) {
      focusTrap.addEventListener('focus', (event) => {
        event.preventDefault()
        closeButton.focus()
      })
    }

    mobileButton &&
      mobileButton.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()

        root.classList.toggle('is-open')
      })
  }

  function attachCloseListenerToOverlay() {
    overlay.addEventListener('click', (event) => {
      event.stopImmediatePropagation()

      root.classList.remove('is-open')
    })
  }

  function isExtraLargeScreen() {
    return window.innerWidth >= SCREEN_WIDTH_EXTRA_LARGE
  }

  function isTabletScreen() {
    return window.innerWidth >= SCREEN_WIDTH_SMALL && window.innerWidth <= SCREEN_WIDTH_LARGE
  }

  function isMobileScreen() {
    return window.innerWidth <= SCREEN_WIDTH_LARGE
  }

  if (dropdown) {
    dropdown.addEventListener('change', () => {
      if (!dropdown.value) return

      if (iframe) iframe.src = dropdown.value
    })
  }
})
